import { getNormas, orderObjects, Response, Search } from "../../../hooks/useNormas";

export const orderValues: string[] = orderObjects.map((v) => v.frontValue);

export async function Submit(search: Search|null, page = 1, order:string = ''): Promise<Response> {
  const orderBackValue = orderObjects.find((value) => value.frontValue === order) || orderObjects[0];
  const response: Response = await getNormas(search, page, orderBackValue.backValue);

  if (!response?.results) return {
    results: [],
    pagination: {
      page: 0,
      pageCount: 0,
      pageSize: 10,
      total: 0
    }
  };

  return {
    results: response?.results,
    pagination: response?.pagination
  };
}